module.exports = __webpack_public_path__ + "static/media/CEA-R-6452.112a6b28.pdf";